module.exports = __webpack_public_path__ + "static/media/steinschlag.204f56d4.svg";